import { createSvgIcon } from '@mui/material'

export const Multi3Icon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='24px'
    viewBox='0 0 24 24'
    width='24px'
    fill='currentColor'
  >
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M11 15H15C15.55 15 16.0208 14.8042 16.4125 14.4125C16.8042 14.0208 17 13.55 17 13V11.5C17 11.0667 16.8583 10.7083 16.575 10.425C16.2917 10.1417 15.9333 10 15.5 10C15.9333 10 16.2917 9.85833 16.575 9.575C16.8583 9.29167 17 8.93333 17 8.5V7C17 6.45 16.8042 5.97917 16.4125 5.5875C16.0208 5.19583 15.55 5 15 5H11V7H15V9H13V11H15V13H11V15ZM8 18C7.45 18 6.97917 17.8042 6.5875 17.4125C6.19583 17.0208 6 16.55 6 16V4C6 3.45 6.19583 2.97917 6.5875 2.5875C6.97917 2.19583 7.45 2 8 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H8ZM8 16H20V4H8V16ZM4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V6H4V20H18V22H4Z'
      fill='currentColor'
    />
  </svg>,
  'Multi3Icon',
)
